export default __webpack_public_path__ + "static/media/usage_tile_bg_dark.0dfe6164.jpg";